import { HomeSupplementaryMaterialsPage } from './HomeSupplementaryMaterialsPage';
export default HomeSupplementaryMaterialsPage;
